import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'md',
    border: '1px solid',
    borderColor: 'whiteAlpha.300',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'md',
    mb: '0',
    bgGradient:
      'linear(to-b, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05))',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textAlign: 'left',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'bold',
    color: 'white',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.2)',
  },
  footerFlex: {
    as: 'footer',
    bg: 'alpha.500',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'medium',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.300',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'lg',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'whiteAlpha.400',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'alpha.100',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    color: 'white',
    fontWeight: 'medium',
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'capitalize',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: '4',
    primaryColor: 'alpha.600',
    secondaryColor: 'beta.200',
    w: '10',
    sx: {
      svg: {
        color: 'beta.200',
        w: '8',
        h: '4',
      },
    },
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'normal',
    color: 'white',
    fontFamily: 'accent',
  },
  footerMatchLinkIcon: {
    color: 'white',
    fontSize: 'md',
  },
};
